module.exports = __webpack_public_path__ + "img/eems.4d7bbf7a.svg";